export default function WindowsDoorServices() {
  const services = [
    {
      icon: 'ri-window-line',
      title: 'Window Replacement',
      description: 'Complete window replacement services including vinyl, wood, aluminum, and fiberglass windows for improved energy efficiency and aesthetics'
    },
    {
      icon: 'ri-door-open-line',
      title: 'Entry Door Installation',
      description: 'Professional installation of entry doors, including steel, fiberglass, and wood doors with enhanced security features and weather sealing'
    },
    {
      icon: 'ri-layout-grid-line',
      title: 'Patio Door Systems',
      description: 'Sliding glass doors, French doors, and bi-fold door installations that connect indoor and outdoor living spaces seamlessly'
    },
    {
      icon: 'ri-tools-line',
      title: 'Custom Window Design',
      description: 'Custom-sized and specialty windows including bay, bow, casement, and picture windows tailored to your home architecture'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Storm Door Installation',
      description: 'Durable storm door installation for added protection, ventilation, and energy savings while extending the life of your entry door'
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Door & Window Finishing',
      description: 'Professional finishing services including painting, staining, and trim work to complement your home exterior and interior design'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Comprehensive Window & Door Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From energy-efficient window replacements to custom door installations, our network of contractors provides complete solutions for El Paso homeowners
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-teal-500 text-white rounded-lg mb-6">
                <i className={`${service.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
